<template lang="pug">
  app-plotly(nomeDiv="graficoRentimento", :dados="graficoDados", :layout="layout")
</template>

<script>
import _ from 'lodash'
import AppPlotly from '@/components/AppPlotly'
import utils from '@/utils/utils'
import { meses } from '@/utils/constantes'

export default {
  components: {
    AppPlotly
  },

  props: {
    dadosLabels: {
      type: Array,
      required: true
    },
    filtro: {
      required: true
    },
    isProdutividadePeriodoAnoMes: {
      type: Boolean,
      required: true
    }
  },

  data () {
    return {
      dados: [],
      layout: {
        showlegend: false,
        xaxis: {
          title: '',
          tickfont: {
            size: 12,
            color: 'rgb(107, 107, 107)'
          },
          fill: 'tozeroy',
          automargin: true
        },
        yaxis: {
          title: 'Produtividade do setor',
          titlefont: {
            size: 16,
            color: 'rgb(107, 107, 107)'
          },
          tickfont: {
            size: 12,
            color: 'rgb(107, 107, 107)'
          }
        }
      },
      loading: true
    }
  },

  methods: {
    sort () {
      this.dadosLabels.sort(utils.compararData)
    },
    generateChartArray () {
      let filtroDataInicial = this.getDataInicial()
      let filtroDataFim = this.getDataFim()

      if (filtroDataInicial && filtroDataFim) {
        let auxDatas = this.generateArraysMonths(filtroDataInicial, filtroDataFim)
        let itemAux = null

        auxDatas.forEach((data, index) => {
          if (index < this.dadosLabels.length) {
            if (parseInt(data.ano) !== parseInt(this.dadosLabels[index].ano) || parseInt(data.mes) + 1 !== parseInt(this.dadosLabels[index].mes)) {
              itemAux = {
                ano: parseInt(data.ano),
                mes: (data.mes + 1) > 9 ? ((data.mes + 1)).toString() : '0' + (data.mes + 1),
                produtividade: 0,
                dia: null,
                nullmediaProdutividade: null
              }
              this.dadosLabels.splice(index, 0, itemAux)
            }
          } else {
            itemAux = {
              ano: parseInt(data.ano),
              mes: (data.mes + 1) > 9 ? ((data.mes + 1)).toString() : '0' + (data.mes + 1),
              produtividade: 0,
              dia: null,
              nullmediaProdutividade: null
            }
            this.dadosLabels.push(itemAux)
          }
        })
      }
    },

    generateArraysMonths (filtroDataInicial, filtroDataFim) {
      let dataInicialObj = new Date(filtroDataInicial)
      let dataFimObj = new Date(filtroDataFim)
      dataInicialObj.setDate(dataInicialObj.getDate() + 1)

      let monthsArray = []
      while (dataInicialObj.getTime() < dataFimObj.getTime()) {
        monthsArray.push({ano: dataInicialObj.getFullYear(), mes: dataInicialObj.getMonth()})
        if (dataInicialObj.getMonth() === 11) {
          dataInicialObj.setYear(dataInicialObj.getFullYear() + 1)
          dataInicialObj.setMonth(0)
          dataInicialObj.setDate(1)
        } else {
          dataInicialObj.setMonth(dataInicialObj.getMonth() + 1)
        }
      }
      return monthsArray
    },

    getDataInicial () {
      let filtroDataInicial = this.filtro.dataInicio
      if (!filtroDataInicial) {
        var now = new Date()
        filtroDataInicial = new Date(now.getFullYear() - 1, now.getMonth() + 1, now.getDate())
      }
      return filtroDataInicial
    },

    getDataFim () {
      let filtroDataFim = this.filtro.dataFim
      if (!filtroDataFim) {
        filtroDataFim = new Date()
      }
      return filtroDataFim
    }
  },

  computed: {
    hasData () {
      return !_.isEmpty(this.dados)
    },
    graficoDados () {
      if (_.isEmpty(this.dadosLabels)) {
        return []
      }

      if (this.isProdutividadePeriodoAnoMes) {
        this.generateChartArray()
      }

      this.sort()

      const graficoDados = [{
        x: [],
        y: [],
        type: 'scatter',
        fill: 'tozeroy'
      }]

      // TODO: Pensar em algum jeito do backend mandar se é agrupado por mes ou dia
      const isMonth = !this.dadosLabels[0].dia

      // Se o filtro veio por mês
      if (isMonth) {
        for (let index = 0; index < this.dadosLabels.length; index++) {
          const data = this.dadosLabels[index]

          graficoDados[0].x.push(meses.get(data.mes) + '/' + data.ano)
          graficoDados[0].y.push(this.dadosLabels[index].produtividade)
        }
        return graficoDados
      }

      // Se o filtro veio por dia
      for (let index = 0; index < this.dadosLabels.length; index++) {
        const data = this.dadosLabels[index]

        graficoDados[0].x.push(data.dia + ' de ' + meses.get(data.mes))
        graficoDados[0].y.push(this.dadosLabels[index].produtividade)
      }

      return graficoDados
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/screens/produtividade/components/GraficoRendimento.vue